export const MY_RECENT_ACTIVITIES_GRID_RECORD_MESSAGE = 'No records to display at this time.';

export const VIEW_GRID_COLUMNS = new Set([
  {
    dataName: 'appSection',
    text: 'App Section',
    sortable: true,
    isSorted: 0,
    headerWidth: 85,
    isHeaderTruncated: true,
  },
  {
    dataName: 'referenceId',
    text: 'Ref ID',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'activity',
    text: 'Activity',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    headerWidth: 190,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'dateTime',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
]);

export enum ActionTypesMyRecentActivities {
  SET_MY_RECENT_ACTIVITIES_DATA = 'SET_MY_RECENT_ACTIVITIES_DATA',
  TOGGLE_IS_MY_RECENT_ACTIVITIES_DATA_LOADING = 'TOGGLE_IS_MY_RECENT_ACTIVITIES_DATA_LOADING',
}
